/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
    readonly color?: string;
}

export default function CircleNew({ className = null, color = '#434F54' }: Props) {
    return (
        <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" transform="matrix(1 0 0 -1 0 24)" fill="#DAE5E9" />
            <circle cx="9" cy="9" r="9" transform="matrix(1 0 0 -1 3 21)" fill="#DAE5E9" />
            <g clipPath="url(#clip0_891_28547)">
                <path d="M17.9539 10.5134C17.9015 10.3427 17.8041 10.1908 17.6727 10.0752C17.5413 9.95959 17.3813 9.885 17.2111 9.85997L14.1805 9.40055L12.8252 6.53574C12.7492 6.37495 12.6316 6.23954 12.4857 6.14486C12.3398 6.05018 12.1714 6 11.9996 6C11.8277 6 11.6593 6.05018 11.5134 6.14486C11.3675 6.23954 11.2499 6.37495 11.174 6.53574L9.8186 9.40055L6.78804 9.85997C6.61811 9.88583 6.4585 9.96074 6.32723 10.0762C6.19595 10.1917 6.09825 10.3432 6.04514 10.5136C5.99204 10.6839 5.98565 10.8664 6.0267 11.0403C6.06775 11.2143 6.1546 11.3728 6.27744 11.498L8.47102 13.7281L7.95322 16.8765C7.9237 17.0532 7.94229 17.235 8.00687 17.4012C8.07145 17.5675 8.17943 17.7115 8.31854 17.8169C8.45766 17.9223 8.62233 17.9849 8.79384 17.9976C8.96536 18.0103 9.13684 17.9725 9.28881 17.8886L11.9996 16.402L14.7103 17.8886C14.8624 17.9717 15.0337 18.0089 15.2049 17.9959C15.3761 17.9829 15.5404 17.9202 15.6793 17.815C15.8182 17.7097 15.9261 17.5661 15.9909 17.4003C16.0557 17.2344 16.0747 17.053 16.0459 16.8765L15.5281 13.7281L17.7217 11.4974C17.8452 11.3727 17.9324 11.2143 17.9735 11.0402C18.0146 10.8662 18.0078 10.6836 17.9539 10.5134Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_891_28547">
                    <rect width="12" height="12" fill="white" transform="translate(6 6)" />
                </clipPath>
            </defs>
        </svg>
    );
}
